import {ReactNode, useEffect, useState} from "react";
import {CognitoJwtVerifier} from "aws-jwt-verify";
import {useLocation} from "react-router-dom";
import Cookies from "js-cookie";
import {
    ACCESS_TOKEN_KEY,
    COOKIES_COMPANY_ID,
    COOKIES_COMPANY_NAME,
    DOMAIN_NAME,
    REFRESH_TOKEN_KEY
} from "../../helper/constants";
import {useAuth, useChat} from "../../context";

function AppWrapper(props: {children?: ReactNode}) {
    const location = useLocation();
    const [refresh, setRefresh] = useState(true);
    const auth = useAuth();
    const chat = useChat();
    // Verifier that expects valid access tokens:
    function deleteAppCookies({ domain = false }: { domain?: boolean }) {
        const cookiesToRemove = [
            ACCESS_TOKEN_KEY,
            REFRESH_TOKEN_KEY,
            COOKIES_COMPANY_ID,
            COOKIES_COMPANY_NAME,
        ];
        cookiesToRemove.forEach(function cookieRemover(name) {
            Cookies.remove(name, {
                domain: domain
                    ? `${process.env.REACT_APP_TRAILER_LOAD_APP}`
                    : undefined,
            });
        });
    }
    const getTokenExpiryDate = () => {
        const idToken = Cookies.get(ACCESS_TOKEN_KEY);
        if (idToken) {
            const payload = JSON.parse(atob(idToken.split(".")[1]));
            const expiry = new Date(payload.exp * 1000);
            return expiry;
        }
    };
    useEffect(function () {
        const expiration = getTokenExpiryDate();
        if (expiration) {
            const timeToExpire = expiration.getTime() - new Date().getTime();
            setTimeout(() => {
                sessionStorage.clear();
                localStorage.clear();
                deleteAppCookies({domain: false});
                // reload the page to redirect user to login page.
                window.location.reload();
            }, timeToExpire);
        }
    }, []);
    useEffect(function () {
        if (auth.user) {
            chat.actions.setUser(auth.user);
        }
    }, [auth.user]);
    useEffect(function () {
        async function verifyToken() {
            const verifier = CognitoJwtVerifier.create({
                userPoolId: `${process.env.REACT_APP_USERPOOL_ID}`,
                tokenUse: "id",
                clientId: `${process.env.REACT_APP_CLIENT_ID}`,
            });
            let link: URL;
            if (refresh) {
                deleteAppCookies({domain: true});
            }
            // Check if the access token is stored in localStorage
            const accessTokenFromLocalStorage = Cookies.get(ACCESS_TOKEN_KEY);
            // Check if the access token is provided as a query parameter
            const queryParams = new URLSearchParams(window.location.search);
            const accessTokenFromQueryParam = queryParams.get("token");
            const accessToken =
                accessTokenFromQueryParam !== null || ""
                    ? accessTokenFromQueryParam
                    : accessTokenFromLocalStorage;
            try {
                await verifier.verify(`${accessToken}`);
                Cookies.set(ACCESS_TOKEN_KEY, `${accessToken}`, {
                    domain: DOMAIN_NAME,
                });
                await auth.fetchUser();
            } catch {
                link = new URL(`${process.env.REACT_APP_ADMIRAL_APP}`);
                link.searchParams.set(
                    "from",
                    encodeURIComponent(window.location.href)
                );
                window.location.assign(link.href);
            }
        };
        verifyToken();
        setRefresh(false);
    }, [location]);
    return <>{props.children}</>;
}

export default AppWrapper;
